<!--====== NAVBAR NINE PART START ======-->

<section class="navbar-area navbar-nine sticky">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <nav class="navbar navbar-expand-lg">
          <!-- <a class="navbar-brand" href="index.html">
            <img src="assets/images/white-logo.svg" alt="Logo" />
          </a> -->
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNine"
            aria-controls="navbarNine"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="toggler-icon"></span>
            <span class="toggler-icon"></span>
            <span class="toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse sub-menu-bar" id="navbarNine">
            <ul class="navbar-nav me-auto">
              <li class="nav-item">
                <a class="page-scroll active" href="#hero-area">Home</a>
              </li>
              <li class="nav-item">
                <a class="page-scroll" href="#services">Services</a>
              </li>

              <li class="nav-item">
                <a class="page-scroll" href="#pricing">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="page-scroll" href="#contact">Contact</a>
              </li>
            </ul>
          </div>

          <!-- <div class="navbar-btn d-none d-lg-inline-block">
            <a class="menu-bar" href="#side-menu-left"
              ><i class="lni lni-menu"></i
            ></a>
          </div> -->
        </nav>
        <!-- navbar -->
      </div>
    </div>
    <!-- row -->
  </div>
  <!-- container -->
</section>

<!--====== NAVBAR NINE PART ENDS ======-->

<!--====== SIDEBAR PART START ======-->

<div class="sidebar-left">
  <div class="sidebar-close">
    <a class="close" href="#close"><i class="lni lni-close"></i></a>
  </div>
  <div class="sidebar-content">
    <div class="sidebar-logo">
      <a href="index.html"><img src="assets/images/logo.svg" alt="Logo" /></a>
    </div>
    <p class="text">
      Lorem ipsum dolor sit amet adipisicing elit. Sapiente fuga nisi rerum
      iusto intro.
    </p>
    <!-- logo -->
    <div class="sidebar-menu">
      <h5 class="menu-title">Quick Links</h5>
      <ul>
        <li><a href="javascript:void(0)">About Us</a></li>
        <li><a href="javascript:void(0)">Our Team</a></li>
        <li><a href="javascript:void(0)">Latest News</a></li>
        <li><a href="javascript:void(0)">Contact Us</a></li>
      </ul>
    </div>
    <!-- menu -->
    <div class="sidebar-social align-items-center justify-content-center">
      <h5 class="social-title">Follow Us On</h5>
      <ul>
        <li>
          <a href="javascript:void(0)"
            ><i class="lni lni-facebook-filled"></i
          ></a>
        </li>
        <li>
          <a href="javascript:void(0)"
            ><i class="lni lni-twitter-original"></i
          ></a>
        </li>
        <li>
          <a href="javascript:void(0)"
            ><i class="lni lni-linkedin-original"></i
          ></a>
        </li>
        <li>
          <!-- <a href="javascript:void(0)"><i class="lni lni-youtube"></i></a> -->
        </li>
      </ul>
    </div>
    <!-- sidebar social -->
  </div>
  <!-- content -->
</div>
<div class="overlay-left"></div>

<!--====== SIDEBAR PART ENDS ======-->

<!-- Start header Area -->
<section id="hero-area" class="header-area header-eight">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 col-12">
        <div class="header-content">
          <h1>Hi, I'm Romir!</h1>
          <p>
            I usually go by drumble or paperclip online. I'm a software engineer that focuses on full-stack web development and dev-ops.
          </p>
          <div class="button">
            <a href="#contact" class="btn primary-btn">Get Started</a>
            <!-- <a
              href="https://www.youtube.com/watch?v=r44RKWyfcFw&fbclid=IwAR21beSJORalzmzokxDRcGfkZA1AtRTE__l5N4r09HcGS5Y6vOluyouM9EM"
              class="glightbox video-button"
            >
              <span class="btn icon-btn rounded-full">
                <i class="lni lni-play"></i>
              </span>
              <span class="text">Watch Intro</span>
            </a> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-12">
        <!-- <div class="header-image">
          <img src="assets/images/header/hero-image.jpg" alt="#" />
        </div> -->
      </div>
    </div>
  </div>
</section>
<!-- End header Area -->

<!-- ===== service-area start ===== -->
<section id="services" class="services-area services-eight">
  <!--======  Start Section Title Five ======-->
  <div class="section-title-five">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <h6>Services</h6>
            <h2 class="fw-bold">Our Best Services</h2>
            <p>
              I host many services that are available to the public. I have a few listed below, but I'm always open to new ideas and projects.
            </p>
          </div>
        </div>
      </div>
      <!-- row -->
    </div>
    <!-- container -->
  </div>
  <!--======  End Section Title Five ======-->
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-capsule"></i>
          </div>
          <div class="service-content">
            <h4>Your own design</h4>
            <p>
              You choose the design and I'll make it happen. I can make a design from scratch or use a template.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-bootstrap"></i>
          </div>
          <div class="service-content">
            <h4>Bootstrap and other UI frameworks</h4>
            <p>
              I can use Bootstrap, Tailwind, or any other UI framework to make your website look great. Say the word and I'll make it happen.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-shortcode"></i>
          </div>
          <div class="service-content">
            <h4>UI Libraries</h4>
            <p>
              I can use UI libraries like React, Angular, or Vue to make your website interactive and user-friendly.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-dashboard"></i>
          </div>
          <div class="service-content">
            <h4>Speed Optimized</h4>
            <p>
              I can make your website load faster by optimizing images, code, and other assets.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-layers"></i>
          </div>
          <div class="service-content">
            <h4>Fully Customizable</h4>
            <p>
              Customize your website to your heart's content. I can make it look and feel exactly how you want it to.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="single-services">
          <div class="service-icon">
            <i class="lni lni-reload"></i>
          </div>
          <div class="service-content">
            <h4>Regular Updates</h4>
            <p>
              Pipeline updates are available to keep your website up-to-date and secure.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ===== service-area end ===== -->

<!-- Start Pricing  Area -->
<section id="pricing" class="pricing-area pricing-fourteen">
  <!--======  Start Section Title Five ======-->
  <div class="section-title-five">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <h6>Pricing</h6>
            <h2 class="fw-bold">Pricing & Plans</h2>
            <p>
              Here are some of the pricing plans that I offer. I'm always open to new ideas and projects, so feel free to reach out to me if you have something in mind.
            </p>
          </div>
        </div>
      </div>
      <!-- row -->
    </div>
    <!-- container -->
  </div>
  <!--======  End Section Title Five ======-->
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <div class="pricing-style-fourteen">
          <div class="table-head">
            <h4 class="title">Discord Bots</h4>
            <p>
              Deploying a Discord bot is a great way to automate tasks and make your server more interactive. I can also make your discord server more secure, user-friendly and fun.
            </p>
            <div class="price">
              <h2 class="amount">
                <span class="currency">$</span>1<span class="duration"
                  >/mo
                </span>
              </h2>
            </div>
          </div>

          <!-- <div class="light-rounded-buttons">
            <a href="javascript:void(0)" class="btn primary-btn-outline">
              Start free trial
            </a>
          </div> -->

          <div class="table-content">
            <ul class="table-list">
              <li><i class="lni lni-checkmark-circle"></i> Customizable bots.</li>
              <li><i class="lni lni-checkmark-circle"></i> Integration with other projects.</li>
              <li><i class="lni lni-checkmark-circle"></i> Secure discord server and make it more interactive with custom functions.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <div class="pricing-style-fourteen middle">
          <div class="table-head">
            <h4 class="title">Web Application</h4>
            <p>
              Customizable web applications that can be used for a variety of purposes. I can make your website look and feel exactly how you want it to.
            </p>
            <div class="price">
              <h2 class="amount">
                <span class="currency">$</span>10<span class="duration"
                  >/mo
                </span>
              </h2>
            </div>
          </div>

          <!-- <div class="light-rounded-buttons">
            <a href="javascript:void(0)" class="btn primary-btn">
              Start free trial
            </a>
          </div> -->

          <div class="table-content">
            <ul class="table-list">
              <li><i class="lni lni-checkmark-circle"></i> Customizable web applications.</li>
              <li><i class="lni lni-checkmark-circle"></i> Free backend support.</li>
              <li><i class="lni lni-checkmark-circle"></i> Use any UI libraries.</li>
              <li><i class="lni lni-checkmark-circle"></i> Competetive pricing for setup and maintenance.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <div class="pricing-style-fourteen">
          <div class="table-head">
            <h4 class="title">Landing Pages</h4>
            <p>
              Customizable landing pages that can be used for a variety of purposes. I can make your website look and feel exactly how you want it to. Simple sites can be made in a few hours.
            </p>
            <div class="price">
              <h2 class="amount">
                <span class="currency">$</span>5<span class="duration"
                  >/mo
                </span>
              </h2>
            </div>
          </div>

          <!-- <div class="light-rounded-buttons">
            <a href="javascript:void(0)" class="btn primary-btn-outline">
              Start free trial
            </a>
          </div> -->

          <div class="table-content">
            <ul class="table-list">
              <li><i class="lni lni-checkmark-circle"></i> Customizable landing pages.</li>
              <li><i class="lni lni-checkmark-circle"></i> Use any UI libraries.</li>
              <li><i class="lni lni-checkmark-circle"></i> Competetive pricing for setup and maintenance.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ End Pricing  Area -->

<!-- Start Cta Area -->
<section id="call-action" class="call-action">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-9">
        <div class="inner-content">
          <h2>We love to make perfect <br />solutions for your business.</h2>
          <p>
            You can contact me for any project or idea you have in mind. I'm always open to new ideas and projects. <br>
            I can support your business with a variety of services that I offer.
          </p>
          <div class="light-rounded-buttons">
            <a href="#contact" class="btn primary-btn-outline"
              >Get Started</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Cta Area -->

<!-- ========================= contact-section start ========================= -->
<section id="contact" class="contact-section">
  <div class="container">
    <div class="row">
      <div class="col-xl-4">
        <div class="contact-item-wrapper">
          <div class="row">
            <div class="col-12 col-md-6 col-xl-12">
              <div class="contact-item">
                <div class="contact-icon">
                  <i class="lni lni-phone"></i>
                </div>
                <div class="contact-content">
                  <h4>Contact</h4>
                  <p>09910310181</p>
                  <p>drumblebotxromir@gmail.com</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-12">
              <div class="contact-item">
                <div class="contact-icon">
                  <i class="lni lni-map-marker"></i>
                </div>
                <div class="contact-content">
                  <h4>Address</h4>
                  <p>1630 9th Ave, Taguig, Metro Manila</p>
                  <p>Philippines</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-12">
              <div class="contact-item">
                <div class="contact-icon">
                  <i class="lni lni-alarm-clock"></i>
                </div>
                <div class="contact-content">
                  <h4>Schedule</h4>
                  <p>24 Hours / 7 Days Open</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="contact-form-wrapper">
          <div class="row">
            <div class="col-xl-10 col-lg-8 mx-auto">
              <div class="section-title text-center">
                <span> Get in Touch </span>
                <h2>Ready to Get Started</h2>
                <p>
                  Contact me for any project or idea you have in mind. I'm always open to new ideas and projects.
                </p>
              </div>
            </div>
          </div>
          <form action="#" class="contact-form">
            <div class="row">
              <div class="col-md-6">
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Name"
                  required
                />
              </div>
              <div class="col-md-6">
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Phone"
                  required
                />
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  name="subject"
                  id="email"
                  placeholder="Subject"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea
                  name="message"
                  id="message"
                  placeholder="Type Message"
                  rows="5"
                ></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="button text-center rounded-buttons">
                  <button type="submit" class="btn primary-btn rounded-full">
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- ========================= contact-section end ========================= -->

<!-- ========================= map-section end ========================= -->
<section class="map-section map-style-9">
  <div class="map-container">
    <object
      style="border: 0; height: 500px; width: 100%"
      data="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.8054132591883!2d121.0533074!3d14.5531174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397c8f38eccbe7d%3A0xb320dfeb845d5f3e!2sOne%20World%20Place%2C%209th%20Ave%2C%20Taguig%2C%20Metro%20Manila!5e0!3m2!1sen!2sph!4v1737387925372!5m2!1sen!2sph"
    ></object>
  </div>
</section>
<!-- ========================= map-section end ========================= -->

<!-- Start Footer Area -->
<footer class="footer-area footer-eleven">
  <!-- Start Footer Top -->
  <div class="footer-top">
    <div class="container">
      <div class="inner-content">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <!-- Single Widget -->
            <div class="footer-widget f-about">
              <!-- <div class="logo">
                <a href="index.html">
                  <img src="assets/images/logo.svg" alt="#" class="img-fluid" />
                </a>
              </div> -->
              <p>
                Solving problems and making the world a better place, one line of code at a time.
              </p>
              <p class="copyright-text">
                <span>© 2025 xRomir.</span>Designed and Developed by
                <a href="https://paperclipper.dev" rel="nofollow"> xRomir </a>
              </p>
            </div>
            <!-- End Single Widget -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--/ End Footer Top -->
</footer>
<!--/ End Footer Area -->

<a href="#" class="scroll-top btn-hover">
  <i class="lni lni-chevron-up"></i>
</a>

<!--====== js ======-->
<script src="assets/js/bootstrap.bundle.min.js"></script>
<script src="assets/js/glightbox.min.js"></script>
<script src="assets/js/main.js"></script>
<script src="assets/js/tiny-slider.js"></script>

<script>
  //===== close navbar-collapse when a  clicked
  let navbarTogglerNine = document.querySelector(
    ".navbar-nine .navbar-toggler"
  );
  navbarTogglerNine.addEventListener("click", function () {
    navbarTogglerNine.classList.toggle("active");
  });

  // ==== left sidebar toggle
  let sidebarLeft = document.querySelector(".sidebar-left");
  let overlayLeft = document.querySelector(".overlay-left");
  let sidebarClose = document.querySelector(".sidebar-close .close");

  overlayLeft.addEventListener("click", function () {
    sidebarLeft.classList.toggle("open");
    overlayLeft.classList.toggle("open");
  });
  sidebarClose.addEventListener("click", function () {
    sidebarLeft.classList.remove("open");
    overlayLeft.classList.remove("open");
  });

  // ===== navbar nine sideMenu
  let sideMenuLeftNine = document.querySelector(".navbar-nine .menu-bar");

  sideMenuLeftNine.addEventListener("click", function () {
    sidebarLeft.classList.add("open");
    overlayLeft.classList.add("open");
  });

  //========= glightbox
  GLightbox({
    href: "https://www.youtube.com/watch?v=r44RKWyfcFw&fbclid=IwAR21beSJORalzmzokxDRcGfkZA1AtRTE__l5N4r09HcGS5Y6vOluyouM9EM",
    type: "video",
    source: "youtube", //vimeo, youtube or local
    width: 900,
    autoplayVideos: true,
  });
</script>
